import React, { useState } from 'react';
import { Box, TextField } from '@mui/material'; 
import NumberFormat from 'react-number-format';

interface IListingInteractionTypesRankCellProps {
  rank: number | null;
  index: number;
  onRankChange: (index: number, newRank: number | null) => void;
  onFocus: (event: React.FocusEvent<HTMLInputElement>) => void;
}

export const ListingInteractionTypesRankCell: React.FC<IListingInteractionTypesRankCellProps> = ({ rank: initialRank, index, onRankChange, onFocus }) => {
  const [rank, setRank] = useState<number | null>(initialRank);

  const handleValueChange = (values: { value: string }) => {
    const value = parseInt(values.value, 10);
    if (Number.isNaN(value)) setRank(null);
    setRank(value);
  };

  const handleBlur = () => {
    onRankChange(index, rank);
  };

  return (
    <Box>
      <NumberFormat
        fullWidth
        isNumericString
        decimalScale={0}
        size="small"
        allowNegative={false}
        customInput={TextField}
        value={rank ?? ''}
        onValueChange={handleValueChange}
        onBlur={handleBlur}
        onFocus={onFocus}
      />
    </Box>
  );
};